import '@/assets/css/style-liberty.css'
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

// 导入API配置
import '@/assets/js/requests.js'

const app = createApp(App);

// 全局错误处理
app.config.errorHandler = (err, vm, info) => {
  console.error('Global error:', err, info);
  // 这里可以添加错误上报逻辑
};

app.use(router).mount('#app')
